import Api from './baseService';
import type { UserPreferencesModel } from '@/models';

async function getUserPreferences(): Promise<UserPreferencesModel> {
  const response = await Api.get('user/preferences');
  return response.data as UserPreferencesModel;
}

async function saveUserPreferences(request: UserPreferencesModel): Promise<void> {
  await Api.post('user/preferences', request);
}

export {
  getUserPreferences,
  saveUserPreferences,
}
